module.exports = __webpack_public_path__ + "static/img/16.2109444.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/16.png
// module id = kEiK
// module chunks = 0